<div class="py-2">
  <div>
    <span>{{'lang.globals.type' | translate}}</span>
    <select [(ngModel)]="selectedType" (ngModelChange)="onTypeSelected(selectedType)"
            class="form-select">
      <option *ngFor="let type of typeOptions" [value]="type">{{type}}</option>
    </select>
  </div>

  <div class="mt-4">
    <span>{{'lang.globals.amount' | translate}}</span>
    <div class="d-flex flex-row">
      <sb-button classes="btn-primary btn-sm" (click)="onCountChanged(count-1)">-</sb-button>
      <input class="form-control mr-2"
             type="number"
             [ngModel]="count"
             (ngModelChange)="onCountChanged($event)">
      <sb-button classes="btn-primary btn-sm mr-0" (click)="onCountChanged(count + 1)">+</sb-button>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-4">
    <sb-button (click)="generateLicences()" *ngIf="count < 2" classes="btn-primary">{{count}}
      {{'lang.admin.licenceManagement.create.singular'
        | translate }}</sb-button>
    <sb-button (click)="generateLicences()" *ngIf="count > 1" classes="btn-primary">{{count}}
      {{'lang.admin.licenceManagement.create.plural'
        | translate }}</sb-button>
  </div>
</div>


